import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
    const certifications = [
        'WHO GMP',
        'GMP',
        'GLP',
        'CGMP',
        'ISO 9000'
    ];

    return (
        <div className="about-container">
            <section className="about-intro">
                <h1>About D-Astars</h1>
                <p>Welcome to D-Astars International Trade, a trusted and registered Indian pharmaceutical company dedicated to the manufacturing and marketing of top-quality pharmaceutical formulations. With our own state-of-the-art manufacturing unit featuring sections for Tablets, Capsules, Soft Gelatin Capsules, Betalactum Products, and General Products, we cater to diverse healthcare needs.</p>
                <p>D-Astars proudly serves clients across India and extends its expertise to international markets. Our products are legally approved by relevant authorities and adhere strictly to compliance standards such as WHO-GMP, GMP, and GLP. Our offerings span a wide array of therapeutic segments, including Cardiac, Diabetic, Anticoagulants, Analgesics, Vasodilators, Gastrology, Orthopedics, Respiratory, and General Products.</p>
            </section>

            <section className="company-pillars">
                <div className="pillar-card">
                    <h2>Mission</h2>
                    <p>Our mission is to harness the transformative power of pharmaceuticals to address rare, chronic, and severe illnesses. We are dedicated to providing exceptional, high-quality products that enhance the well-being and health of patients worldwide, ensuring care and innovation are at the heart of everything we do.</p>
                </div>

                <div className="pillar-card">
                    <h2>Vision</h2>
                    <p>Our vision is to establish ourselves as a premier pharmaceutical leader in India and emerge as a prominent global presence by delivering high-quality, accessible, and innovative healthcare solutions that redefine medicine and treatment for a healthier world.</p>
                </div>

                <div className="pillar-card">
                    <h2>Quality</h2>
                    <p>D-Astars International Trade's Quality Policy is driven by a robust Quality Management System, ensuring continuous monitoring and review to uphold the highest standards for patients, customers, and stakeholders.</p>
                </div>
            </section>

            <section className="why-choose-us">
                <h2>Why Choose D-Astars?</h2>
                <div className="features-grid">
                    <div className="feature-card">
                        <i className="fas fa-medal"></i>
                        <h3>Exemplary Quality</h3>
                        <p>Every product we manufacture meets rigorous quality standards, ensuring reliability and excellence.</p>
                    </div>
                    <div className="feature-card">
                        <i className="fas fa-truck"></i>
                        <h3>Punctual Deliveries</h3>
                        <p>Our robust logistics network ensures your orders are delivered on schedule, every time.</p>
                    </div>
                    <div className="feature-card">
                        <i className="fas fa-globe"></i>
                        <h3>Global Reach</h3>
                        <p>Delivering exceptional quality products globally through air, ocean, and road freight.</p>
                    </div>
                </div>
            </section>

            <section className="certifications">
                <h2>Our Certifications</h2>
                <div className="certification-grid">
                    {certifications.map((cert, index) => (
                        <div key={index} className="certification-badge">
                            <i className="fas fa-certificate"></i>
                            <span>{cert}</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
